<template>
    <div></div>
</template>

<script>
    import createPhotoSwipe from '../../../modules/create-photoswipe';

    export default {
        beforeDestroy() {
            if (this.photoswipe) {
                this.photoswipe.destroy();
            }
        },
        methods: {
            open(refs, index, items, options = {}) {
                if (this.photoswipe) {
                    this.photoswipe.destroy();
                }

                const thumbnail = Array.from(refs || []).find(element => Number(element.dataset.index) === Number(index));
                this.photoswipe = createPhotoSwipe(items, {
                    tapAction: 'close',
                    ...options,
                    index,
                });

                if (thumbnail) {
                    this.photoswipe.addFilter('thumbEl', (element, item, itemIndex) => {
                        return itemIndex === Number(index) ? thumbnail.querySelector('img') : element;
                    });
                }

                this.photoswipe.init();
            },
            close() {
                if (this.photoswipe) {
                    this.photoswipe.close();
                }
            },
        },
    };
</script>

<style>
.application-photoswipe {
    z-index: 12000;
}
</style>
